<p-dialog [(visible)]="displayModalReject" [modal]="true" [style]="{width: '40vw'}"
          [draggable]="false" [resizable]="false" (onHide)="cancel()">
    <div class="m-0 reject-body">
        <img src="/XpressApp/assets/images/product/illustration_product_reject.svg" />
        <p class="reject-title">Reject Product</p>
        <p class="reject-description">The product will be temporarily rejected until the merchatnt fixes the problem(s) below</p>
    </div>
    <div class="flex justify-content-center mt-10">
        <p-selectButton [options]="rejectOptions" [(ngModel)]="rejectValue" optionLabel="label" optionValue="value"></p-selectButton>
    </div>
    <div class="flex justify-content-center mt-20" *ngIf="!loadingReject">
        <div>
            <button pButton pRipple type="button" label="Cancel" class="p-button-secondary btn-cancel" (click)="displayModalReject = false"></button>
        </div>
        <div>
            <button pButton pRipple type="button" label="Reject" class="p-button-outlined p-button-warning btn-reject" (click)="saveReject()"></button>
        </div>
    </div>
    <div *ngIf="loadingReject" style="text-align: center;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>
</p-dialog>
